import { render, staticRenderFns } from "./Fotos.vue?vue&type=template&id=184fdd2c&scoped=true&"
import script from "./Fotos.vue?vue&type=script&lang=js&"
export * from "./Fotos.vue?vue&type=script&lang=js&"
import style0 from "./Fotos.vue?vue&type=style&index=0&id=184fdd2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184fdd2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VHover } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VCard,VFlex,VHover,VImg,VLayout,VProgressCircular})
